// @general/companies - frontend surface.

export { useCompanyStore } from './store'
export { useSitesStore } from './sites'
export { brand, brandName, brandPending, brandSettled, brandAsset, applyBrand, loadBrand, useBrandView } from './brand'
export { default as BrandMark } from './components/BrandMark.vue'

export const routes = [
  {
    path: '/company',
    name: 'company',
    component: () => import('./views/CompanyView.vue'),
    meta: { permission: 'company:write', title: 'company.title' },
  },
  {
    // Reading is open to anybody signed in (see the backend), but the screen
    // is a management screen: it is reached by whoever maintains the list.
    path: '/sites',
    name: 'sites',
    component: () => import('./views/SitesView.vue'),
    meta: { permission: 'company:read', title: 'sites.title' },
  },
  // Static before the parameter, for the reader: route ranking already handles
  // it. Creating a site is a screen and not a dialog, like every other form in
  // the ERP — behind `company:write`, so nobody reaches a form they cannot
  // submit.
  {
    path: '/sites/new',
    name: 'site-new',
    component: () => import('./views/SiteView.vue'),
    meta: { permission: 'company:write', title: 'sites.newTitle' },
  },
  {
    // The existing one reads for anybody who can read the list, and the form is
    // disabled without `company:write`: the same screen, one row of buttons
    // fewer.
    path: '/sites/:id',
    name: 'site',
    component: () => import('./views/SiteView.vue'),
    meta: { permission: 'company:read', title: 'sites.editTitle' },
  },
]

export const navigation = [
  { to: '/company', labelKey: 'company.title', permission: 'company:write', icon: 'building', group: 'platform' },
  { to: '/sites', labelKey: 'sites.title', permission: 'company:read', icon: 'sites', group: 'platform' },
]

export default { routes, navigation }
